import Vue from 'vue';
import Vuex from 'vuex';
import ApiService from '../services/api.service.js';
import AuthService from '../services/auth.service.js';
import JwtService from '../services/jwt.service';
import * as profile from './modules/profile.js';
import * as distributors from './modules/distributors.js';
import * as subscriptions from './modules/subscriptions.js';
import * as clients from './modules/clients.js';
import * as catalogues from './modules/catalogues.js';
import * as notifications from './modules/notifications.js';
import * as permissions from './modules/permissions.js';
import * as payments from './modules/payments.js';
import * as global from './modules/global.js';
import * as admins from './modules/admins.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userData: null
  },
  getters: {
    loggedIn: (state) => Boolean(state.profile.profileData)
  },
  mutations: {
    SET_USER_DATA(state, userData) {
      ApiService.defaults.headers.common['x-auth-token'] = userData.token;
      state.userData = userData;
    },
    CLEAR_USER_DATA() {
      JwtService.destroyTokens();
      location.reload(); /* Vuex state does not survive a browser refresh */
    }
  },
  actions: {
    async login({ dispatch }, { username, password, sid }) {
      try {
        const {
          data: { token: sessionToken, refreshToken }
        } = await AuthService.login({ username, password, sid });
        JwtService.saveSessionToken(sessionToken);
        let userData = { username, refreshToken };
        userData = await dispatch('setApiKey', userData);
        return userData;
      } catch (err) {
        // eslint-disable-next-line
        console.error(err);
      }
    },
    async setApiKey({ commit, dispatch }, data = {}) {
      try {
        const { username, refreshToken } = data;
        if (!JwtService.getApiKey()) {
          const {
            data: { token }
          } = await AuthService.requestApiKey();
          JwtService.saveApiKey(token);
        }
        const userData = {
          token: JwtService.getApiKey(),
          username,
          refreshToken
        };
        commit('SET_USER_DATA', userData);

        await dispatch('getPermissions');
        await dispatch('getProfile');

        return userData;
      } catch (err) {
        // eslint-disable-next-line
        console.error(err);
      }
    },
    logout({ commit }) {
      commit('CLEAR_USER_DATA');
    }
  },
  modules: {
    admins,
    profile,
    distributors,
    clients,
    catalogues,
    global,
    subscriptions,
    notifications,
    permissions,
    payments
  }
});
